import axios from 'axios';
import './axios-interceptor';

export default {
  async getEventByStateCity(state: string, city: string) {
    return await axios.get(`event/list/${state}/${city}`);
  },
  async getEvent(param: any, searchParam: string) {
    return await axios.get(`event/list?limit=${param.limit}&lastIndex=${param.lastIndex}&${searchParam}`);
  },
};
